import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { formatMetodoPago, formatSplitValue } from "src/shared/helpers/formatMetodoPago"
import { GastosDetailProps } from "./GastosDetail.type"
import "./GastosDetail.css"

const emptyValue = "-"

const cajaChicaValues = ["si", "sí", "true", "1"]

const formatCajaChica = (value?: string) => {
    if (!value) {
        return emptyValue
    }

    return cajaChicaValues.includes(value.trim().toLowerCase()) ? "Sí" : "No"
}

const GastosDetail = ({ isOpen, onClose, data }: GastosDetailProps): JSX.Element => {
    // las fechas del reporte ya llegan formateadas desde el endpoint, se muestran igual que en la tabla
    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="gastos-detail">
            <div className="gastos-detail__head">
                <p className="gastos-detail__title">Gasto</p>
                <p className="gastos-detail__subtitle">{data?.Folio || emptyValue}</p>
            </div>
            <div className="gastos-detail__body">
                <div className="gastos-detail__description">
                    <DescriptionDetail
                        icon={"FolderFill"}
                        label={"Categoría"}
                        value={data?.Categoria || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"bookMark"}
                        label={"Subcategoría"}
                        value={data?.Subcategoria || emptyValue}
                    />
                    <DescriptionDetail
                        className={"gastos-detail__value--multiline"}
                        icon={"draft"}
                        label={"Descripción del gasto"}
                        value={data?.Descripcion || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Monto"}
                        value={formatCurrencyToFixed(Number(data?.monto) || 0)}
                    />
                    <DescriptionDetail
                        className={"gastos-detail__value--full"}
                        icon={"creditCard"}
                        label={"Método de pago"}
                        value={formatSplitValue(data?.metodo_pago, formatMetodoPago)}
                    />
                    <DescriptionDetail
                        icon={"money"}
                        label={"Caja chica"}
                        value={formatCajaChica(data?.caja_chica)}
                    />
                    <DescriptionDetail
                        className={"gastos-detail__value--full"}
                        icon={"userFilled"}
                        label={"Responsable"}
                        value={data?.Responsable || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"calendarFill"}
                        label={"Fecha de registro"}
                        value={data?.Fecha_registro || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"calendarChecked"}
                        label={"Fecha de gasto"}
                        value={data?.Fecha_gasto || emptyValue}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default GastosDetail
